export default "__VITE_ASSET__Bry3z$xt__"